import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  adminData: {},
  pageFlag: 'create'
}

export const userSlice = createSlice({
  name: 'admin',
  initialState,
  reducers: {
    // 自动生成 action creator 和 reducer
    setAdminDataAction: (state, action) => {
      state.adminData = action.payload
    },
    setAdminPageFlagAction: (state, action) => {
      state.pageFlag = action.payload
    },
  }
})

// 自动生成的 action creators
export const { setAdminDataAction, setAdminPageFlagAction } = userSlice.actions

// Selectors
export const selectAdminData = (state) => state.admin.adminData
export const selectAdminPageFlag = (state) => state.admin.pageFlag

// Reducer
export default userSlice.reducer